import { useTranslation } from "next-i18next";

import { InfoLayout } from "@/layouts/InfoLayout";
import { getSiteSettings } from "@/services/sanity";
import { getAllTranslationsServerSide } from "@/utils/i18n";

export default function Mission() {
  const { t } = useTranslation("info", {
    keyPrefix: "terms_of_sale",
  });
  const title = t("title");
  const description = t("description");

  return <InfoLayout title={title} description={description} type="terms" />;
}

export async function getStaticProps({ locale }) {
  const siteSettings = await getSiteSettings();

  return {
    props: {
      ...(await getAllTranslationsServerSide(locale, ["info"])),
      siteSettings,
    },
  };
}
